import {IDirective, IOnDestroy, IOnInit} from "angular";
import {NVD3Util} from "../../../js/util/NVD3Util";
import {AppUtil} from "../../../js/util/AppUtil";

export const NvTooltip = "nvTooltip";

export function nvTooltip(): IDirective {
    return {
        restrict: "A",
        controller: NVD3TooltipPatchController
    };
}

export class NVD3TooltipPatchController implements IOnInit, IOnDestroy {

    private hideFn: EventListenerOrEventListenerObject;

    public $onInit(): void {
        this.hideFn = AppUtil.throttle(NVD3Util.hideAllTooltips, 500);
        window.addEventListener("scroll", this.hideFn, {passive: true});
    }

    public $onDestroy(): void {
        NVD3Util.hideAllTooltips();
        window.removeEventListener("scroll", this.hideFn);
    }
}
